import CssBaseline from '@material-ui/core/CssBaseline'
import { createMuiTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import mediaQuery from 'css-mediaquery'
import Head from 'next/head'
import React, { useMemo } from 'react'
import { DefaultTheme, ThemeProvider as SCThemeProvider } from 'styled-components'

import { useSiteConfig } from '../siteconfig'

const ThemeProvider: React.FC = ({ children }) => {
  const { themeOptions, googleFontsUrl, typekitFontsUrl } = useSiteConfig()

  const theme = useMemo(() => {
    const ssrMatchMedia = (query: string) => ({
      matches: mediaQuery.match(query, {
        width: '1024px',
      }),
    })
    return createMuiTheme({
      ...themeOptions,
      props: {
        MuiUseMediaQuery: { ssrMatchMedia },
      },
    })
  }, [themeOptions])

  return (
    <>
      <Head>
        <meta content={theme.palette.primary.main} name="theme-color" />
        {googleFontsUrl && <link href={`${googleFontsUrl}&display=swap`} rel="stylesheet" />}
        {typekitFontsUrl && <link href={typekitFontsUrl} rel="stylesheet" />}
      </Head>

      <SCThemeProvider theme={theme as DefaultTheme}>
        <MuiThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          {children}
        </MuiThemeProvider>
      </SCThemeProvider>
    </>
  )
}

export default ThemeProvider
